import type { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, tap, mergeMap } from 'rxjs/operators';

import { RewardsActions } from '../../../rewards/data/store/rewards.store';
import { OfferAssignmentsHttpService } from './offer-assignments-http.service';
import { OfferAssignmentsActions } from './offer-assignments.store';
import { OfferFiltersActions } from './offer-filters.store';

@Injectable({ providedIn: 'root' })
export class OfferAssignmentsEffects {
  public loadOfferAssignments = createEffect(() =>
    this.actions$.pipe(
      ofType(OfferAssignmentsActions.fetchCollection),
      mergeMap(({ payload }) =>
        this.offerAssignmentsHttpService.loadOfferAssignments(payload.params).pipe(
          tap(data => {
            this.store.dispatch(
              RewardsActions.fetchCollectionSuccess({
                payload: { data: data.references },
              }),
            );
          }),
          map(data =>
            OfferAssignmentsActions.fetchCollectionSuccess({
              payload: {
                data: data.offerAssignments,
                scope: payload.scope,
                replace: payload.replace,
                meta: data.meta,
              },
            }),
          ),
          catchError(error =>
            of(OfferAssignmentsActions.fetchCollectionFailed({ payload: error })),
          ),
        ),
      ),
    ),
  );

  public loadOfferAssignmentsDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OfferAssignmentsActions.fetchOne),
      mergeMap(({ payload }) =>
        this.offerAssignmentsHttpService.loadOfferAssignmentDetails(payload.id).pipe(
          map(({ offerAssignment }) =>
            OfferAssignmentsActions.fetchOneSuccess({
              payload: { data: offerAssignment },
            }),
          ),
          catchError((error: HttpErrorResponse) =>
            of(OfferAssignmentsActions.fetchOneFail({ payload: { error } })),
          ),
        ),
      ),
    ),
  );

  public loadOfferFilters$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OfferFiltersActions.fetch),
      mergeMap(() =>
        this.offerAssignmentsHttpService.loadOfferFilters().pipe(
          map(data =>
            OfferFiltersActions.fetchSuccess({
              payload: data,
            }),
          ),
          catchError(error => of(OfferFiltersActions.fetchFailed({ payload: error }))),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private offerAssignmentsHttpService: OfferAssignmentsHttpService,
    private store: Store,
  ) {}
}
